/**
 * Component showing the parameters of Stereo To Spatial on the home page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025.
 */

import { useState } from 'react'
import { Tooltip } from 'react-tooltip'
import ModuleConfigList from '../../ModuleConfig/ModuleConfigList'
import { ModuleKey } from '../../ModuleConfig/ModuleInfo'
import '../styles/homemodule.css'

export interface StereoToSpatialParamProps {
  updateModuleParamList: (newParam: Record<string, any>) => void
}

/**
 * Component displaying the selection of the parameters for Stereo To Spatial.
 */
const StereoToSpatialParamComp = (props: StereoToSpatialParamProps) => {
  // Ensure options exist, defaulting to an empty array
  const paramDef =
    ModuleConfigList[ModuleKey.StereoToSpatial].paramList?.[0] || null
  const paramName = paramDef?.name ?? 'param'
  const optionList = paramDef?.options || []

  // Find the default option (first one with defaultValue: true),
  // fallback to first option
  const defaultOption =
    optionList.find((option) => option.defaultValue) || optionList[0]
  const defaultValue = defaultOption ? defaultOption.value : ''

  // Store the selected value in state
  const [selectedValue, setSelectedValue] = useState(defaultValue)

  function valueChanged(e: any) {
    const value = e.target.value
    setSelectedValue(value)
    props.updateModuleParamList({ [paramName]: value })
  }

  return (
    <div className="param-comp stereo-to-spatial-param">
      <div className="param-label">
        <div>Preset</div>
        <img
          data-tooltip-id="tooltip-preset"
          data-tooltip-place="bottom"
          src="/icon/question-mark.svg"
          width="16px"
          height="16px"
        />
      </div>
      <Tooltip
        id="tooltip-preset"
        content="Create a greater or more subtle effect"
        className="tooltip"
      />
      <select
        // Ensure the selected option matches state
        value={selectedValue}
        // Update state when user selects an option
        onChange={valueChanged}
      >
        {optionList?.map(
          (option: { value: string; title: string }, index: number) => (
            <option key={index} value={option.value}>
              {/* Remove index from title */}
              {option.title.replace(/^\d+\s+/, '')}
            </option>
          )
        )}
      </select>
    </div>
  )
}

export default StereoToSpatialParamComp
